import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	PostFinishRequestPreview,
	PostFinishRequestPreviewParams,
	PostFinishRequestPreviewResponse,
} from 'domain/usecases/private/refund/request-preview';

export class RemotePostFinishRequestPreview implements PostFinishRequestPreview {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PostFinishRequestPreviewResponse>,
	) {}

	async post(params: PostFinishRequestPreviewParams): Promise<PostFinishRequestPreviewResponse> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body: params,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
